import React from 'react';
import { Building2, Upload, FileText, X } from 'lucide-react';

// 1. Define el tipo de las secciones
export type Section = 'profile' | 'documents' | 'invoices';

// 2. Define las props que el componente va a recibir
interface MenuProps {
  activeSection: Section;                    // El estado actual
  setActiveSection: (section: Section) => void;  // La funci�n para cambiarlo
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (open: boolean) => void;
}

const Menu: React.FC<MenuProps> = ({
  activeSection,
  setActiveSection,
  isMobileMenuOpen,
  setIsMobileMenuOpen
}) => {

  // 3. Configuración del menú (igual que antes)
  const menuItems = [
    {
      id: 'profile' as Section,
      name: 'Perfil',
      icon: Building2,
      description: 'Información del centro médico'
    },
    {
      id: 'documents' as Section,
      name: 'Reportes',
      icon: Upload,
      description: 'Subir documentos tributarios'
    },
    {
      id: 'invoices' as Section,
      name: 'Facturas',
      icon: FileText,
      description: 'Ver facturas generadas'
    }
  ];

  return (
    <>
      {/* Sidebar Menu - Desktop */}
      <aside className="hidden lg:block w-80 bg-white rounded-lg shadow-lg p-6 h-fit sticky top-8">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Menú de Navegación</h2>
        <nav className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeSection === item.id;

            return (
              <button
                key={item.id}
                onClick={() => setActiveSection(item.id)}  // 4. Usa la función del padre
                className={`w-full flex items-start gap-3 p-4 rounded-lg transition-all ${
                  isActive
                    ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-md'
                    : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
                }`}
              >
                <Icon size={24} className={isActive ? 'text-white' : 'text-blue-600'} />
                <div className="text-left">
                  <div className={`font-semibold ${isActive ? 'text-white' : 'text-gray-800'}`}>
                    {item.name}
                  </div>
                  <div className={`text-sm ${isActive ? 'text-blue-100' : 'text-gray-500'}`}>
                    {item.description}
                  </div>
                </div>
              </button>
            );
          })}
        </nav>

        {/* Info Box */}
        <div className="mt-6 p-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg border border-blue-200">
          <h3 className="font-semibold text-blue-900 mb-2">¿Necesitas ayuda?</h3>
          <p className="text-sm text-blue-800 mb-3">
            Contáctanos si tienes alguna duda sobre tu cuenta o facturación.
          </p>
          <a
            href="/contact"
            className="text-sm text-blue-700 hover:text-blue-900 font-semibold underline"
          >
            Ir a Contacto →
          </a>
        </div>
      </aside>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-50">
          <div className="bg-white w-80 h-full p-6 shadow-xl">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg font-semibold text-gray-800">Menú de Navegación</h2>
              <button
                onClick={() => setIsMobileMenuOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-lg transition"
              >
                <X size={24} />
              </button>
            </div>

            <nav className="space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = activeSection === item.id;

                return (
                  <button
                    key={item.id}
                    onClick={() => {
                      setActiveSection(item.id);
                      setIsMobileMenuOpen(false);
                    }}
                    className={`w-full flex items-start gap-3 p-4 rounded-lg transition-all ${
                      isActive
                        ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-md'
                        : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    <Icon size={24} className={isActive ? 'text-white' : 'text-blue-600'} />
                    <div className="text-left">
                      <div className={`font-semibold ${isActive ? 'text-white' : 'text-gray-800'}`}>
                        {item.name}
                      </div>
                      <div className={`text-sm ${isActive ? 'text-blue-100' : 'text-gray-500'}`}>
                        {item.description}
                      </div>
                    </div>
                  </button>
                );
              })}
            </nav>

            <div className="mt-6 p-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg border border-blue-200">
              <h3 className="font-semibold text-blue-900 mb-2">¿Necesitas ayuda?</h3>
              <p className="text-sm text-blue-800 mb-3">
                Contáctanos si tienes alguna duda sobre tu cuenta o facturación.
              </p>
              <a
                href="/contact"
                className="text-sm text-blue-700 hover:text-blue-900 font-semibold underline"
              >
                Ir a Contacto →
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Menu;
